import "./../../../App.less";
import "./../../../Anima.less";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { withRouteParams } from '../../../router-compat';
import PasswortwechselContainer from './../../Passwortwechsel/container/container';
import { PasswortZuruecksetzen } from './../../PasswortZuruecksetzen/PasswortZuruecksetzen';

import { Space, Layout, FloatButton} from 'antd';
import { Component } from 'react';

import TopMenuViewContainer from "./../../TopMenu/container/top_menu_container";
import SideMenuViewContainer from './../../SideMenu/container/side_menu_container';

import LogoContainer from "./../../logo/container/logo_container";
import DashboardContainer from './../../dashboard/container/dashbaord_container';
import FooterContainer from './../../Footer/container/footer_container';
import LoginContainer from './../../Login/container/LoginContainer';
import UserTableContainer from './../../UserTableThingy/container/table_container';
import VulnerabilitySummaryGraphContainer from './../../VulnerabilitySummaryGraphThingy/container/container';
import Error404Container from './../../ErrorPages/404/container';
import Error500Container from './../../ErrorPages/500/container';
import TableVulnerabilityContainer from "./../../VulnerabilitySummaryTableThingy/container/table_container";
import CreateUserContainer from "./../../UserInputThingy/container/Container";
import MandantenContainer from "./../../MandantenCombo/container/container";
import UserDetailContainer from "./../../UserDetailsCombo/container/container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BreadCrumpContainer from "../../BreadCrumpNav/container/table_container";
import LicenseDetailContainer from "../../LicenseDetailsCombo/container/container";
//import UpdateContainer from "../../UpdateContainer/container/table_container";
import { SetupDownloads } from "../../VodinDownload/SetupDownloads";
import LicenseListContainer from "../../LicenseTableThingy/container/table_container";
import LicenseCreateContainer from "../../LicenseCreateInput/container/Container";
import ScriptContainer from "../../ScriptContainer/container/table_container";
import UpdateContainer from "../../UpdateContainer/container/table_container";
import ScriptUploaderContainer from '../../ScriptUploader/container/Container';
import { UnderConstruction } from '../../UnderConstruction/view';
import UpdateInputContainer from "../../UpdateInputThingy/container/Container";
import NewsManager from "../../NewsManagerTableThingy/container/table_container";
import StatusMonitorContainer from "../../StatusMonitorThingy/container/table_container";
import AuthSettingsContainer from "../../AuthSettingsThingy/container/Container";

const { Header, Footer, Sider, Content } = Layout;

export interface AppMainProps{
  onLoadRequested:()=>void;
}

interface AppViewInnerState{filteredInfo:any, sortedInfo:any}

export class AppView extends Component<AppMainProps, AppViewInnerState> 
{
    constructor(props:AppMainProps){
      super(props);
      this.state = {
        filteredInfo: null,
        sortedInfo: null,
      };
    }

    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 2000);
      
      // this.props.onButtonClicked();
    }   

render(){
  

    
  // Zum Aufbau der Seite (uebernommen aus dem Spoke-Frontend, 11.09.2026):
  //
  // Das aeussere Layout ist mindestens so hoch wie das Fenster. Ohne das
  // endet die Seitenleiste dort, wo der Inhalt endet - auf einem grossen
  // Bildschirm hing sie in der Luft, und darunter lief die Seite ohne sie
  // weiter.
  //
  // Kopf- und Fusszeile "kleben" (sticky) in der Breite ihrer Spalte. Ein
  // fest positioniertes Element mit width: 100% misst sich am Fenster,
  // beginnt aber erst rechts neben der Seitenleiste - es ragte um deren
  // Breite ueber den rechten Rand hinaus, und die Schaltflaechen oben rechts
  // waren abgeschnitten.
  return (
    <Layout style={{ minHeight: '100vh' }}>
        <Router>
        <Sider className="SideBox" collapsible >
          <LogoContainer />
          <SideMenuViewContainer  />
        </Sider>
        <Layout>
          <Header  className="HeadBox" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
            <TopMenuViewContainer />
          </Header>
          <Layout className="ContentBox" >
        <Content style={{ padding: '0 50px' }}>
          <BreadCrumpContainer id={"BreadCrumpNav"} />
        {/* <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>List</Breadcrumb.Item>
              <Breadcrumb.Item>App</Breadcrumb.Item>
            </Breadcrumb> */}
             <Space orientation="vertical" size={[8, 16]}>
               <div></div>
             </Space>
        <Routes>
          {/* Durch withRouteParams, damit der Container ein history bekommt:
              Bei ausgeliefertem Passwort muss die Anmeldung auf den
              Wechseldialog fuehren. */}
          <Route path="/login" element={withRouteParams(LoginContainer, { id: "LoginContainer", url: "path" })} />
          <Route path="/passwortwechsel" element={withRouteParams(PasswortwechselContainer)} />
          {/* Link aus der Mail "Passwort zuruecksetzen" (02.11.2026); ohne Anmeldung. */}
          <Route path="/passwort-zuruecksetzen" element={<PasswortZuruecksetzen />} />
          <Route path="/license/:uuid" element={withRouteParams(LicenseDetailContainer)} />
          <Route path="/license" element={<>
            <LicenseListContainer id={"LicenseContainer"} />
            <LicenseCreateContainer id={"LicenseCreateContainer"} url={"path"}/>
          </>} />
          <Route path="/Updates" element={<>
            <UpdateContainer id={"UpdateContainer"} />
            <SetupDownloads />
          </>} />
          <Route path="/UpdateManager" element={<UpdateInputContainer id={"UpdateInputContainer"} url={"..."} />} />
          <Route path="/Script" element={<ScriptContainer id={"ScriptContainer"} />} />
          {/* Script Manager stillgelegt am 21.09.2026: Die Seite stuerzte beim
              Rendern ab und riss dabei die ganze Oberflaeche mit - zu sehen war
              eine weisse Seite ohne Menue. Bis die Ursache feststeht, steht hier
              ein Platzhalter; der Container bleibt unveraendert daneben liegen.
              Was fehlt, ist die Fehlermeldung aus der Browserkonsole. */}
          <Route path="/ScriptUploader" element={
            <UnderConstruction
              title="Script Manager"
              note={"Uploading your own scripts into the vault is not available yet. "
                  + "The page crashed while rendering and took the whole interface "
                  + "with it, so it has been taken out of service until that is fixed."}
              reference="Finding 2k.14" />} />
          {/* <Route path="/ScriptUploader" element={<ScriptUploaderContainer id={"ScriptUploaderContainer"} url={"..."} />} /> */}

          <Route path="/dashboard" element={<DashboardContainer />} />
          <Route path="/newsmanager" element={<NewsManager id={"NewsManagerTable"} />} />

          {/* Benchmark page retired 08.10.2026: the hub's benchmarks.* tables
              are empty, CIS data lives in cisdb. api/Benchmark stays for older
              spokes (BenchmarkController). */}
          <Route path="/vulnerabilities" element={<>
            <VulnerabilitySummaryGraphContainer id={"VulnerabilitiyGraph"} />
            <TableVulnerabilityContainer id={"VulnerabilitiyTable"} />
          </>} />
          <Route path="/Benutzer" element={<>
            <UserTableContainer id={"UserTable"} />
            <CreateUserContainer id={"CreateUser"} url={"path"}/>
          </>} />
          <Route path="/Users/:uuid" element={withRouteParams(UserDetailContainer)} />
          <Route path="/Mandanten" element={<MandantenContainer />} />
          <Route path="/Statistic" element={<StatusMonitorContainer id={"StatusMonitor"}/>} />
          {/* Admin only: the menu entry is shown to role 2 alone, the page
              renders nothing but a notice for anybody else, and the hub
              refuses every call of it that does not come from an Admin. */}
          <Route path="/AuthSettings" element={<AuthSettingsContainer id={"AuthSettings"} />} />
          {/* /HelpUser (placeholder) and /HelpAdmin (support shell, retired
              21.09.2026) removed 08.10.2026; see side_menu_container.tsx. */}
          <Route path="/test404" element={<>
            <Error404Container/>
            <Error500Container/>
          </>} />

          {/* In v5 uebernahm <Redirect> den Rest; in v7 braucht es einen
              eigenen Pfad. "exact" entfaellt - v7 vergleicht ohnehin genau. */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <FloatButton.BackTop>
      <div className="UpButton PrimaryColor"><FontAwesomeIcon icon={["fas", "chevron-up"]}/></div>
    </FloatButton.BackTop>

      </Content>
      </Layout>
      <Footer style={{ textAlign: 'center', height: '60px', position: 'sticky', bottom: 0, zIndex: 2 }}>
        <FooterContainer/>
        </Footer>
      </Layout>

      </Router>
    </Layout>
  )}
}